import axiosConnector from './axiosConnector';
import { Customer } from './interfaces/apiInterfaces';

export interface GetCustomersResponse {
  customers: Customer[];
  userHasIndependentContext: boolean;
}

export const getAllCustomers = async (): Promise<GetCustomersResponse> => {
  const response = await axiosConnector.get<GetCustomersResponse>('/customer');
  return response.data;
};

export const getCustomerById = async (customerId: number): Promise<Customer> => {
  const response = await axiosConnector.get<Customer>(`/customer/${customerId}`);
  return response.data;
};

export const getCustomerBuildings = async (customerId: number) => {
  const response = await axiosConnector.get(`/customer/${customerId}/buildings`);
  return response.data;
};

export const getCustomerEquipment = async (customerId: number): Promise<any[]> => {
  const response = await axiosConnector.get<any[]>(`/customer/${customerId}/equipment`);
  return response.data;
};

export const getCustomerUsers = async (customerId: number) => {
  const response = await axiosConnector.get(`/customer/${customerId}/users`);
  return response.data;
};

export const createCustomer = async (customerData: Partial<Customer>): Promise<Customer> => {
  const response = await axiosConnector.post<Customer>('/customer', customerData);
  return response.data;
};

export const updateCustomer = async (customerId: number, customerData: Partial<Customer>): Promise<Customer> => {
  const response = await axiosConnector.patch<Customer>(`/customer/${customerId}`, customerData);
  return response.data;
};

export const deleteCustomer = async (customerId: number): Promise<void> => {
  await axiosConnector.remove(`/customer/${customerId}`);
};

export const addUserToCustomer = async (customerId: number, userId: number): Promise<void> => {
  await axiosConnector.post(`/customer/${customerId}/users/${userId}`);
};

export const removeUserFromCustomer = async (customerId: number, userId: number): Promise<void> => {
  await axiosConnector.remove(`/customer/${customerId}/users/${userId}`);
};

export const getUserCustomers = async (userId: number): Promise<GetCustomersResponse> => {
  const response = await axiosConnector.get<GetCustomersResponse>(`/users/${userId}/customers`);
  return response.data;
};
